module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('IndividualSummaryOverlay')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-21b5f1bc!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/tabs/LDIndividualSummaryTab.vue
// module id = 1804
// module chunks = 61